import { PartialId } from '@attain-apps/string-builder'
import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type { User } from '../admin'
import * as common from '../common'

/**
 * A logical grouping for organizing related conversations.
 * Conversations without a workspace are considered global.
 */
export type Workspace = common.Identified<Workspace.Id> &
  common.Named &
  common.Described & {
    createdAt: Date
    ownerId: User.Id
    sharedWith: User.Id[]
  }
export namespace Workspace {
  export const isWorkspace: TypeChecker<Workspace> =
    TypeChecker.Factory.intersection(
      common.Identified.getTypeChecker(PartialId.isPartialId),
      common.Named.isNamed,
      common.Described.isDescribed,
      TypeChecker.Factory.object<{
        createdAt: Date
        ownerId: string
        sharedWith: string[]
      }>({
        createdAt: TypeChecker.Factory.instance(Date),
        ownerId: TypeChecker.isString,
        sharedWith: TypeChecker.Factory.list(TypeChecker.isString),
      }),
    )
  export const assertIsWorkspace = TypeAsserter.Factory.from(isWorkspace)
  export type Id = PartialId
  /**
   * Input type for creating a {@link Workspace}.
   */
  export type Input = Required.Semi<
    Partial<Omit<Workspace, 'id' | 'createdAt' | 'ownerId'>>,
    'name'
  >
}
